module.exports = __webpack_public_path__ + "assets/zjmp_icon4.23551b14.svg";